import { render } from "./chatbots.vue?vue&type=template&id=413831ef"
import script from "./chatbots.vue?vue&type=script&lang=js"
export * from "./chatbots.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__